import ArtistFab from "@/components/ArtistFab";
import ArtistsGallery from "@/components/ArtistsGallery";
import MainAppBar from "@/components/MainAppBar";
import { useActiveArtists, useDiscover } from "@/services/hooks";
import {
  Box,
  CircularProgress,
  Container,
  Stack,
  Typography,
} from "@mui/material";

export default function Subscriptions() {
  const { data: artists, isLoading: isLoadingArtists } = useActiveArtists();
  const { data: discover, isLoading: isLoadingDiscover } = useDiscover();

  const isLoading = isLoadingArtists || isLoadingDiscover;

  return (
    <Container maxWidth="sm">
      <MainAppBar />

      <Box sx={{ mt: 10, mb: 6, minHeight: "60vh" }}>
        {isLoading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "40vh",
            }}
          >
            <CircularProgress />
          </Box>
        ) : artists && artists.length > 0 ? (
          <>
            <Typography
              variant="h5"
              sx={{
                fontFamily: "'Montserrat Alternates', sans-serif",
                fontWeight: 700,
                fontSize: "1.4rem",
              }}
            >
              subscriptions
            </Typography>
            <ArtistsGallery artists={artists} />
          </>
        ) : (
          <Stack spacing={4} direction="column">
            <Typography
              variant="h5"
              sx={{
                fontFamily: "'Montserrat Alternates', sans-serif",
                fontWeight: 700,
                fontSize: "1.4rem",
              }}
            >
              discover
            </Typography>
            <ArtistsGallery artists={discover} />
          </Stack>
        )}
      </Box>
      <ArtistFab />
    </Container>
  );
}
